import { EventCard } from "../components/event-card";
import { StateMessage } from "../components/state-message";
import type { ViewProps } from "./types";

export function ListView({
  config,
  events,
  isLoading,
  isLoadingMore,
  errorMessage,
  nextUrl,
  onSelect,
  onLoadMore,
}: ViewProps) {
  const subtitle =
    config.tag.length === 0
      ? "Upcoming events"
      : `Upcoming events for ${config.tag.join(", ")}`;

  const useFooterLinks = Boolean(config.fullCalendarUrl);

  return (
    <>
      {config.showSubtitle ? (
        <header className="gitg-header">
          <p className="gitg-subtitle">{subtitle}</p>
        </header>
      ) : null}

      {isLoading ? <StateMessage>Loading events…</StateMessage> : null}
      {!isLoading && errorMessage ? (
        <StateMessage variant="error">
          Unable to load events: {errorMessage}
        </StateMessage>
      ) : null}
      {!isLoading && !errorMessage && events.length === 0 ? (
        <StateMessage>No matching upcoming events.</StateMessage>
      ) : null}

      {!isLoading && !errorMessage && events.length > 0 ? (
        <div
          className={`gitg-list${useFooterLinks ? " gitg-list--frontpage" : ""}`}
          aria-busy={isLoadingMore}
        >
          {events.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              config={config}
              onSelect={onSelect}
            />
          ))}
        </div>
      ) : null}

      {!isLoading && !errorMessage && (nextUrl || config.fullCalendarUrl) ? (
        useFooterLinks ? (
          <div className="gitg-list-footer-links">
            {nextUrl ? (
              <button
                className="gitg-link-load-more"
                disabled={isLoadingMore}
                onClick={onLoadMore}
                type="button"
              >
                {isLoadingMore ? "Loading…" : "Load more events"}
              </button>
            ) : (
              <span aria-hidden="true" />
            )}
            {config.fullCalendarUrl ? (
              <a
                className="gitg-link-full-calendar"
                href={config.fullCalendarUrl}
                rel="noreferrer noopener"
                target="_blank"
              >
                Open full calendar
              </a>
            ) : null}
          </div>
        ) : (
          <div className="gitg-load-more">
            <button
              className="gitg-load-more-button"
              disabled={isLoadingMore}
              onClick={onLoadMore}
              type="button"
            >
              {isLoadingMore ? "Loading…" : "Load more"}
            </button>
          </div>
        )
      ) : null}
    </>
  );
}
